import React from 'react';
import { Stack, Container, Typography, Paper, List } from '@mui/material';
import ScoringStructureTable from './ScoringStructureTable';
import ChipListItem from '../art/ChipListItem';

const ScoringStructureSection=({scoringStructure})=>
	<Stack direction={{xs:"column",sm:"row"}} justifyContent="space-between" alignItems="flex-end">
		<ScoringStructureTable scoringStructure={scoringStructure} />
		<Container component={Paper} >
			<Typography variant="h4">Notes</Typography>
			<List>
				{ scoringStructure.maxScoresToCount>0 && <ChipListItem>Scores from the best {scoringStructure.maxScoresToCount} games are counted</ChipListItem> }
				{ scoringStructure.maxScoresToCount===0 && <ChipListItem>Scores from all games are counted</ChipListItem> }
				{ scoringStructure.maxScoresToCount>0 && <ChipListItem>If these scores are tied, other games are then counted</ChipListItem> }
				<ChipListItem>If still tied, number of 1st places are then counted</ChipListItem>
			</List>
		</Container>
	</Stack>

export default ScoringStructureSection;
